function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M10.611,16.591a1.679,1.679,0,0,1,0,2.376L9.129,20.449a1.682,1.682,0,0,1-2.376,0l-6.2-6.2a1.682,1.682,0,0,1,0-2.376l1.482-1.482a1.679,1.679,0,0,1,2.376,0ZM.8,15.864a.337.337,0,0,0-.521.056,1.666,1.666,0,0,0,.211,2.106l2.482,2.482a1.666,1.666,0,0,0,2.106.211.337.337,0,0,0,.056-.521ZM11.63,7.085a.673.673,0,0,0-.95,0L7.089,10.676a.672.672,0,0,0,0,.95l2.288,2.288a.673.673,0,0,0,.95,0l3.591-3.591a.672.672,0,0,0,0-.95ZM20.2,5.135a.337.337,0,0,0,.521-.056,1.666,1.666,0,0,0-.212-2.1L18.029.491A1.666,1.666,0,0,0,15.924.279.337.337,0,0,0,15.868.8ZM14.253.551a1.682,1.682,0,0,0-2.376,0L10.4,2.033a1.679,1.679,0,0,0,0,2.376l6.2,6.2a1.679,1.679,0,0,0,2.376,0l1.482-1.482a1.682,1.682,0,0,0,0-2.376Z",
  transform: "translate(-0.003 0)"
});

function SvgGym(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.c62ab660.svg";
export { ForwardRef as ReactComponent };